export enum AddContactPermission {
  OptInRequired = 'addContact:optInRequired',
  OptOutRequired = 'addContact:optOutRequired',
  NoRequest = 'addContact:noRequest'
}

export enum BulkUploadPermission {
  RequestPermission = 'bulkUpload:requestPermission',
  Permitted = 'bulkUpload:permitted'
}

export enum ContactExportPermission {
  RequestPermission = 'contactExport:requestPermission',
  Permitted = 'contactExport:permitted'
}
